/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ResourceEventType {
    Base = '0',
    ChangedState = 1,
    ChangedLocation = 2,
}
